import { Button, Form, Input, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { WashingMethod } from '@/types'
import { CreateCustomerRequest } from '@/types/apis/customers/CreateCustomerRequest'

import { SpaceCustom } from '../../style'
import { SelectWrapper } from '../styles'

type Props = {
  loading: boolean
  onSubmit: (formValues: CreateCustomerRequest) => void
  washingMethods: WashingMethod[] | undefined
}

const CreateCustomerForm = ({ loading, onSubmit, washingMethods }: Props) => {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Form.Item label={t('components.pages.customers.create.form.code')} name="code">
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.customers.create.form.shortName')}
        name="shortName"
        rules={[{ required: true, message: t('components.pages.customers.create.form.requireShortName') }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('components.pages.customers.create.form.name')}
        name="name"
        rules={[{ required: true, message: t('components.pages.customers.create.form.requireName') }]}
      >
        <Input />
      </Form.Item>

      <SelectWrapper>
        <Form.Item label={t('components.pages.customers.update.form.method')} name="washingMethodIds">
          <Select allowClear mode="multiple">
            {washingMethods?.map((method) => (
              <Select.Option key={method.id} value={method.id}>
                {method.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </SelectWrapper>

      <Form.Item>
        <SpaceCustom>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('components.pages.customers.create.form.submit')}
          </Button>
        </SpaceCustom>
      </Form.Item>
    </Form>
  )
}

CreateCustomerForm.displayName = 'CreateCustomerForm'
export default CreateCustomerForm
